import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

import { type ExamLocationRequestStatus } from '../../types';

const EXAM_LOCATION_REQUEST_STATUSES = ['DRAFT', 'IN_REVIEW', 'REJECTED'] as const;

type SortOrder = (typeof dataGridSortDirection)[number];

export default function useExamLocationRequestListSearchParams() {
  const [
    { status, page, pageSize, sortOrder, sortBy, province, locationName },
    setExamLocationRequestListSearchParams,
  ] = useQueryStates({
    status: parseAsStringLiteral(EXAM_LOCATION_REQUEST_STATUSES).withDefault('DRAFT'),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString,
    province: parseAsString,
    locationName: parseAsString,
  });

  const changePageNumber = (page: number) => {
    setExamLocationRequestListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setExamLocationRequestListSearchParams({ pageSize, page: 0 });
  };

  const changeStatus = (status: ExamLocationRequestStatus) => {
    setExamLocationRequestListSearchParams({ status, page: 0, pageSize: 10 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy?: string | null;
  }) => {
    setExamLocationRequestListSearchParams({ sortOrder, page: 0, sortBy });
  };

  const changeProvince = (province: string) => {
    setExamLocationRequestListSearchParams({ province, page: 0 });
  };

  const changeLocationName = (locationName: string | null) => {
    setExamLocationRequestListSearchParams({ locationName, page: 0 });
  };

  return [
    { status, page, pageSize, sortOrder, sortBy, province, locationName },
    {
      changeStatus,
      changePageNumber,
      changePageSize,
      changeSorting,
      changeProvince,
      changeLocationName,
    },
  ] as const;
}
